import i18n from 'shared/lib/i18n';

import {
  CLEAR_PERSON_BY_ID,
  CLEAR_REGISTERED_USERS_COUNT,
  GET_PERSON_BY_ID_FAILURE,
  GET_PERSON_BY_ID_REQUEST,
  GET_PERSON_BY_ID_SUCCESS,
  GET_PERSON_DETAILS_FAILURE,
  GET_PERSON_DETAILS_REQUEST,
  GET_PERSON_DETAILS_SUCCESS,
  GET_REGISTERED_ALL_COUNT_FAILURE,
  GET_REGISTERED_ALL_COUNT_REQUEST,
  GET_REGISTERED_ALL_COUNT_SUCCESS,
  GET_REGISTERED_PERSONS_COUNT_FAILURE,
  GET_REGISTERED_PERSONS_COUNT_REQUEST,
  GET_REGISTERED_PERSONS_COUNT_SUCCESS,
  MANAGE_CREDENTIALS_FAILURE,
  MANAGE_CREDENTIALS_REQUEST,
  MANAGE_CREDENTIALS_SUCCESS,
  SET_MODAL_TYPE,
  SYNC_ALL_PERSONS_WITH_BMX_FAILURE,
  SYNC_ALL_PERSONS_WITH_BMX_REQUEST,
  SYNC_ALL_PERSONS_WITH_BMX_SUCCESS,
  SYNC_PERSON_WITH_BMX_FAILURE,
  SYNC_PERSON_WITH_BMX_REQUEST,
  SYNC_PERSON_WITH_BMX_SUCCESS,
  SYNC_PERSON_WITH_BRIVO_FAILURE,
  SYNC_PERSON_WITH_BRIVO_REQUESTED,
  SYNC_PERSON_WITH_BRIVO_SUCCEEDED,
  SYNC_RESIDENTS_FROM_YARDI_FAILURE,
  SYNC_RESIDENTS_FROM_YARDI_REQUEST,
  SYNC_RESIDENTS_FROM_YARDI_SUCCESS,
} from '../../actionConstants';

import { diffTimeInMinutes } from '../../utils';

import apiClient from '../../apiClient';
import { CONFIRM } from '../Modal/modalTypes';

export const getPersonDetails = (
  dispatch,
  pmcId,
  buildingId,
  personId,
  personType,
) => {
  const propertyType = buildingId ? 'building' : 'pmc';
  const propertyId = buildingId || pmcId;
  return dispatch({
    type: GET_PERSON_DETAILS_REQUEST,
    payload: apiClient[propertyType][`${personType}ById`](
      propertyId,
      personId,
    ).then(
      (res) =>
        dispatch({
          type: GET_PERSON_DETAILS_SUCCESS,
          pmcId,
          buildingId,
          personId,
          res,
        }),
      (err) =>
        dispatch({
          type: GET_PERSON_DETAILS_FAILURE,
          err,
        }),
    ),
  });
};

export const getPersonById = (dispatch, personId) =>
  dispatch({
    type: GET_PERSON_BY_ID_REQUEST,
    payload: apiClient.admin.getPersonById(personId).then(
      (res) => {
        dispatch({
          type: GET_PERSON_BY_ID_SUCCESS,
          res,
        });
        return res?.data;
      },
      (err) =>
        dispatch({
          type: GET_PERSON_BY_ID_FAILURE,
          err,
        }),
    ),
  });

export const clearPerson = (dispatch) =>
  dispatch({
    type: CLEAR_PERSON_BY_ID,
  });

export const syncWithBrivo = (dispatch, buildingId, personId) =>
  dispatch({
    type: SYNC_PERSON_WITH_BRIVO_REQUESTED,
    payload: apiClient.building.syncPersonWithBrivo(buildingId, personId).then(
      (res) =>
        dispatch({
          type: SYNC_PERSON_WITH_BRIVO_SUCCEEDED,
          res,
          successMessage: i18n.t('syncActions.brivoSynced'),
        }),
      (err) =>
        dispatch({
          type: SYNC_PERSON_WITH_BRIVO_FAILURE,
          err,
        }),
    ),
  });

export const syncWithBMX = (dispatch, buildingId, personId) =>
  dispatch({
    type: SYNC_PERSON_WITH_BMX_REQUEST,
    payload: apiClient.building.syncPersonWithBMX(buildingId, personId).then(
      (res) =>
        dispatch({
          type: SYNC_PERSON_WITH_BMX_SUCCESS,
          res,
          successMessage: i18n.t('syncActions.bmxSynced'),
        }),
      (err) =>
        dispatch({
          type: SYNC_PERSON_WITH_BMX_FAILURE,
          err,
        }),
    ),
  });

export const syncAllWithBMX = (dispatch, buildingId) =>
  dispatch({
    type: SYNC_ALL_PERSONS_WITH_BMX_REQUEST,
    payload: apiClient.building.syncBMXPersons(buildingId).then(
      (res) =>
        dispatch({
          type: SYNC_ALL_PERSONS_WITH_BMX_SUCCESS,
          res,
          successMessage: i18n.t('syncActions.bmxSynced'),
        }),
      (err) =>
        dispatch({
          type: SYNC_ALL_PERSONS_WITH_BMX_FAILURE,
          err,
        }),
    ),
  });

export const promptForSyncAllPersonsWithBMX = (dispatch, buildingId) => {
  const modalProps = {
    bodyText: i18n.t('person.syncBmxRequest'),
    confirmText: i18n.t('common.yes'),
    cancelText: i18n.t('common.no'),
    onConfirm: () => syncAllWithBMX(dispatch, buildingId),
  };
  return dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });
};

export const syncResidentsFromYardi = (dispatch, buildingId, data) =>
  dispatch({
    type: SYNC_RESIDENTS_FROM_YARDI_REQUEST,
    payload: apiClient.building.syncYardiResidents(buildingId, data).then(
      (res) =>
        dispatch({
          type: SYNC_RESIDENTS_FROM_YARDI_SUCCESS,
          res,
          successMessage: i18n.t('syncActions.yardiStarted'),
        }),
      (err) => {
        const timestamp =
          err?.response?.data?.data?.last_sync_trigger_timestamp;
        const errorMessage = err?.response?.data?.msg;
        const minutesAgo =
          timestamp &&
          diffTimeInMinutes(Date.now(), new Date(timestamp * 1000));
        return dispatch({
          type: SYNC_RESIDENTS_FROM_YARDI_FAILURE,
          err,
          message:
            minutesAgo &&
            i18n.t('person.timeSyncStarted', {
              minute: minutesAgo,
              error: errorMessage,
            }),
        });
      },
    ),
  });

export const getRegisteredPersonCount = (dispatch, type, id, queryParams) =>
  dispatch({
    type: GET_REGISTERED_PERSONS_COUNT_REQUEST,
    payload: apiClient.registeredUsersCount[type](id, queryParams).then(
      (res) => {
        dispatch({
          type: GET_REGISTERED_PERSONS_COUNT_SUCCESS,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_REGISTERED_PERSONS_COUNT_FAILURE,
          err,
        }),
    ),
  });

export const getRegisteredAllCount = (dispatch, queryParams) =>
  dispatch({
    type: GET_REGISTERED_ALL_COUNT_REQUEST,
    payload: apiClient.registeredUsersCount.all(queryParams).then(
      (res) =>
        dispatch({
          type: GET_REGISTERED_ALL_COUNT_SUCCESS,
          res,
        }),
      (err) =>
        dispatch({
          type: GET_REGISTERED_ALL_COUNT_FAILURE,
          err,
        }),
    ),
  });

export const clearRegisteredUsersCount = (dispatch) =>
  dispatch({
    type: CLEAR_REGISTERED_USERS_COUNT,
  });

export const managePersonCredentials = (dispatch, personId, data) =>
  dispatch({
    type: MANAGE_CREDENTIALS_REQUEST,
    isForm: true,
    payload: apiClient.person.manageCredentials(personId, data).then(
      (res) => {
        dispatch({
          type: MANAGE_CREDENTIALS_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        dispatch({
          type: MANAGE_CREDENTIALS_FAILURE,
          err,
        });
      },
    ),
  });
